import React, { useState } from "react"
import ReactTooltip from "react-tooltip"

import katikaSEOImage from "../../src/assets/images/katikaSEOImage.png"

import Layout from "../components/layout"
import SimpleMapChart from "../components/simple-map-chart"
import InstructionsModal from "../components/instructions-modal"
import SEO from "../components/seo"

const Index = () => {
  const [countryCode, setCountryCode] = useState("??")

  const [content, setContent] = useState("")

  return (
    <Layout countryCode={countryCode} setCountryCode={setCountryCode}>
      <SEO
        title="Katika Projects"
        description="Explore black music around the world!"
        image={katikaSEOImage}
      />
      <main>
        <InstructionsModal />
        <SimpleMapChart
          setTooltipContent={setContent}
          setCountryCode={setCountryCode}
        />
        <ReactTooltip backgroundColor="black">{content}</ReactTooltip>
      </main>
    </Layout>
  )
}

export default Index
